export default "__VITE_PUBLIC_ASSET__74e95eb4__"